<section class="custom-product-card">
  <section class="custom-card-header">
    <section>
      <a [routerLink]="['/product', productInfo.code, productInfo.code]">
        <cx-media
          class="cx-product-image"
          [container]="productInfo.images?.PRIMARY"
          format="product"
        [alt]="productInfo.summary"></cx-media>
      </a>
      @if (
        productInfo?.images === undefined || productInfo?.images?.length === 0
        ) {
        <a
          [routerLink]="['/product', productInfo.code, productInfo.code]"
          >
          <img
            class="image-set-in-card product-img"
            [src]="fallbackImage"
            alt="" />
        </a>
      }
    </section>
    <section class="product-name">
      <a [routerLink]="['/product', productInfo.code, productInfo.code]">
        <h6>{{ productInfo.name }}</h6>
      </a>
    </section>
  </section>

  @if (!iconDisplay) {
    <section class="custom-card-body">
      <p
        class="custom-tab-p display-type"
      [innerHTML]="
        sanitizer.bypassSecurityTrustHtml(description | slice: 0 : 300)
      "></p>
      @if (description?.length > 300) {
        <a
          class="show-more display-type"
          [routerLink]="['/product', productInfo.code, productInfo.code]">
          ...Show More
        </a>
      }
    </section>
  }

  @if (iconDisplay) {
    <section class="custom-card-body">
      <section class="info-tabs">
        <app-my-tabs>
          <app-my-tab tabIcon="information.svg" class="product-detail">
            <div class="padding-0">
              <p class="custom-tab-title">{{ 'plp.details' | cxTranslate }}</p>
              @if (description !== undefined) {
                <p
                  class="custom-tab-p display-type"
              [innerHTML]="
                sanitizer.bypassSecurityTrustHtml(description | slice: 0 : 300)
              "></p>
              }
              @if (description?.length > 300) {
                <a
                  class="show-more display-type"
                  [routerLink]="['/product', productInfo.code, productInfo.code]">
                  ...Show More
                </a>
              }
            </div>
          </app-my-tab>
          @if (productInfo.batchInfo?.batchNumber) {
            <app-my-tab
              tabIcon="icn-batchexpiry.svg">
              <div class="padding-0">
                <p class="custom-tab-title">
                  {{ 'plp.batchNumber' | cxTranslate }}
                </p>
                <p class="batchinfo-p">{{ productInfo.batchInfo?.batchNumber }}</p>
                @if (sessionStorage.getItem('accountType') !== 'INDIRECT') {
                  <div>
                    <p class="custom-tab-title">
                      {{ 'plp.expiryDate' | cxTranslate }}
                    </p>
                    <p class="batchinfo-p">{{ productInfo.batchInfo?.expiryDate }}</p>
                  </div>
                }
                <p class="custom-tab-p">{{ 'plp.batchInfo' | cxTranslate }}</p>
              </div>
            </app-my-tab>
          }
          @if (
            productInfo?.volumePrices?.length > 0 && userDetails !== undefined
            ) {
            <app-my-tab
              tabIcon="icons/volume.png">
              <div class="padding-0">
                <section class="prodtabs-cont prod-promotab active">
                  <p class="custom-tab-title">
                    {{ 'plp.volumeDiscounts' | cxTranslate }}
                  </p>
                  <section class="discount-list">
                    <table aria-describedby="cartTable" class="volume-table">
                      <thead>
                        <th id=""></th>
                      </thead>
                      @for (
                        prices of productInfo?.volumePrices; track
                        prices; let i = $index) {
                        <tbody
                          >
                          <tr>
                            <td>
                              {{ prices?.minQuantity }} - {{ prices?.maxQuantity }}
                              {{ 'plp.units' | cxTranslate }}:
                            </td>
                            <td>{{ prices?.value | localCurrency }}</td>
                            <td>
                              @if (i > 0) {
                                <span class="save-price">
                                  {{ 'plp.volumePricesSave' | cxTranslate }}
                                  {{
                                  productInfo?.volumePrices[0].value -
                                  productInfo?.volumePrices[i].value | currency
                                  }}
                                </span>
                              }
                            </td>
                          </tr>
                        </tbody>
                      }
                    </table>
                  </section>
                </section>
              </div>
            </app-my-tab>
          }
          @if (monographLink) {
            <app-my-tab tabIcon="excel-sample.svg">
              <div class="padding-0">
                <p class="custom-tab-title">{{ 'plp.monograph' | cxTranslate }}</p>
                <p class="custom-tab-p">
                  <img class="pdf-icon" src="icons/pdf.png" alt="" />
                  <a
                    alt=""
                    [href]="monographLink"
                    target="_blank"
                    class="file-link blue">
                    {{ 'plp.monograph' | cxTranslate }}
                  </a>
                </p>
              </div>
            </app-my-tab>
          }
          @if (productInfo?.productUpdates) {
            <app-my-tab tabIcon="warning.svg">
              <div class="padding-0">
                <p class="custom-tab-title">
                  {{ 'plp.productUpdate' | cxTranslate }}
                </p>
                <p class="custom-tab-p productupdate-p">
                  {{ productInfo?.productUpdates | slice: 0 : 300 }}
                </p>
                @if (productInfo?.productUpdates?.length > 300) {
                  <a
                    class="show-more display-type"
                    [routerLink]="['/product', productInfo.code, productInfo.code]">
                    ...Show More
                  </a>
                }
              </div>
            </app-my-tab>
          }
        </app-my-tabs>
      </section>
    </section>
  }
  <section class="custom-card-footer">
    <section class="prod-num">
      <strong>
        {{ 'plp.productNumber' | cxTranslate }}: {{ productInfo.code }}
      </strong>
    </section>
    @if (userDetails !== undefined) {
      <section>
        <section>
          @if (!productInfo.flu) {
            <section
              class="row unit-calc"
          [ngClass]="{
            'visible-hide':
              productInfo?.price == null ||
              productInfo?.price == undefined ||
              productInfo?.price?.value == 0.0,
          }">
              @if (
                productInfo?.price == null ||
                productInfo?.price == undefined ||
                productInfo?.price?.value == 0.0
                ) {
                <section
                  class="no-price"
                  >
                  <p>{{ 'plp.noPrice' | cxTranslate }}</p>
                </section>
              }
              <section class="price-details">
                <strong>{{ 'plp.yourPrice' | cxTranslate }}</strong>
                <section class="price-total">
                  @if (
                    productInfo?.price == undefined ||
                    productInfo?.price?.value === undefined
                    ) {
                    <span
                      >
                      -
                    </span>
                  }
                  @if (
                    productInfo?.price && productInfo?.price?.value !== undefined
                    ) {
                    <span
                      >
                      <span>{{ productInfo?.price?.value | localCurrency }}</span>
                      {{ 'plp.cad' | cxTranslate }}
                    </span>
                  }
                </section>
                @if (
                  productInfo?.price &&
                  productInfo?.price?.b2BUnitDisplayName !== undefined
                  ) {
                  <span
                    >
                    <strong>{{ 'plp.soldBy' | cxTranslate }}&nbsp;</strong>
                    <span>{{ productInfo?.price?.b2BUnitDisplayName }}</span>
                  </span>
                }
              </section>
              @if (!productInfo?.discontinued && productInfo?.available) {
                <section
                  class="units"
                  >
                  <strong class="prodUnits">{{ 'plp.units' | cxTranslate }}</strong>
                  <section class="unit-area">
                    <span
                      class="disabled"
                      aria-hidden="true"
                      id="{{ 'minusIcon' + productInfo.code }}"
                (click)="
                  performQuantityComputation(
                    2,
                    productInfo.code,
                    productInfo.quantityPerUnit
                  )
                ">
                      <img
                        src="icons/less.svg"
                        id="{{ 'unitMinus' + productInfo.code }}"
                        class="disabled-img"
                        alt="" />
                      <img
                        src="icons/less-disable.svg"
                        id="{{ 'unitMinusDisable' + productInfo.code }}"
                        alt="" />
                    </span>
                    <input
                      type="number"
                      class="prod-quantity text-center"
                      value="1"
                (keyup)="
                  performQuantityComputation(
                    null,
                    productInfo.code,
                    productInfo.quantityPerUnit
                  )
                "
                      onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                      id="{{ 'prodQuantity' + productInfo.code }}"
                      maxlength="7" />
                    <span
                      class=""
                      aria-hidden="true"
                      id="{{ 'plusIcon' + productInfo.code }}"
                (click)="
                  performQuantityComputation(
                    1,
                    productInfo.code,
                    productInfo.quantityPerUnit
                  )
                ">
                      <img
                        src="icons/more.svg"
                        id="{{ 'unitPlus' + productInfo.code }}"
                        alt="" />
                      <img
                        src="icons/more-disable.svg"
                        id="{{ 'unitPlusDisable' + productInfo.code }}"
                        class="disabled-img"
                        alt="" />
                    </span>
                  </section>
                  <section
                    class="dosessection"
                    id="{{ 'noOfDoses' + productInfo.code }}">
                    {{ productInfo.quantityPerUnit }} {{ 'plp.doses' | cxTranslate }}
                  </section>
                </section>
              }
              @if (!productInfo?.discontinued && productInfo?.available) {
                <section
                  class="product-info"
                  >
                  @if (productInfo.sapAllocation) {
                    <section>
                      <strong class="prod-allocation">
                        {{ 'plp.productAllocation' | cxTranslate }}
                      </strong>
                      <p class="allocation-p">
                        {{ 'plp.allocationDetails' | cxTranslate }}
                      </p>
                    </section>
                  }
                </section>
              }
              @if (!productInfo?.discontinued && productInfo?.available) {
                <button
                  type="button"
                  class="btn blue-button"
                  [ngbPopover]="popTitleSuccess"
                  placement="bottom"
                  triggers="manual"
                  #p2="ngbPopover"
                  popoverClass="savesuccess-msg"
                  placement="bottom"
                  [closeDelay]="500"
                  (click)="addToCart(productInfo?.code, p2)">
                  @if (buttonName === 'Reserve now') {
                    <em
                      class="fa fa-calendar"
                    aria-hidden="true"></em>
                  }
                  @if (buttonName === 'Add to cart') {
                    <span>
                      {{ 'addToCartItems.addCart' | cxTranslate }}
                    </span>
                  }
                  @if (buttonName === 'Login to order') {
                    <span>
                      {{ 'addToCartItems.loginToOrder' | cxTranslate }}
                    </span>
                  }
                  @if (buttonName === 'Reserve now') {
                    <span>
                      {{ 'addToCartItems.reserveNow' | cxTranslate }}
                    </span>
                  }
                </button>
              }
              <ng-template #popTitleSuccess>
                <div class="cart-value-added">
                  <img
                    src="icons/confirmation-positive-green.png"
                    class="positive-green-icon"
                    alt="success" />
                  <span class="confirmation-itemsadded">
                    {{ itemAddedQuantity }}
                    {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}
                  </span>
                </div>
              </ng-template>
            </section>
          }
          @if (productInfo?.discontinued || !productInfo?.available) {
            <section>
              @if (productInfo?.discontinued && productInfo?.available) {
                <section>
                  <p class="product-discontinued-txt1">
                    {{ 'plp.discontinued' | cxTranslate }}
                  </p>
                </section>
              }
              @if (productInfo?.discontinued && !productInfo?.available) {
                <section>
                  <p class="product-discontinued-txt1">
                    {{ 'plp.discontinued' | cxTranslate }}
                  </p>
                </section>
              }
              @if (!productInfo.discontinued && !productInfo?.available) {
                <section
                  class="m0">
                  @if (productInfo?.availabilityText) {
                    <strong
                      class="prod-allocation"
                      >
                      {{ productInfo?.availabilityText }}
                    </strong>
                  }
                  @if (!productInfo?.availabilityText) {
                    <strong
                      class="prod-allocation"
                      >
                      {{ 'plp.productUnavailable' | cxTranslate }}
                    </strong>
                  }
                </section>
              }
            </section>
          }
          @if (productInfo.flu) {
            <section>
              <section>
                @if (
                  productInfo.flu &&
                  productInfo.available &&
                  !productInfo.discontinued
                  ) {
                  <p
                    class="contact-info m0">
                    {{ 'plp.productAllocationInfo1' | cxTranslate }}
                    <strong>
                      {{ 'plp.emergencycontact' | cxTranslate }}
                    </strong>
                    {{ 'plp.productAllocationInfo2' | cxTranslate }}
                  </p>
                }
                @if (
                  productInfo?.price != null &&
                  productInfo?.price != undefined &&
                  productInfo?.price?.value != 0.0 &&
                  productInfo.flu &&
                  productInfo.available &&
                  !productInfo.discontinued
                  ) {
                  <button
                    type="button"
                    class="btn blue-button m0-spacing"
                    (click)="addToCart(productInfo?.code, p2)">
                    @if (buttonName === 'Reserve now') {
                      <em
                        class="fa fa-calendar"
                      aria-hidden="true"></em>
                    }
                    @if (buttonName === 'Add to cart') {
                      <span>
                        {{ 'addToCartItems.addCart' | cxTranslate }}
                      </span>
                    }
                    @if (buttonName === 'Login to order') {
                      <span>
                        {{ 'addToCartItems.loginToOrder' | cxTranslate }}
                      </span>
                    }
                    @if (buttonName === 'Reserve now') {
                      <span
                        class="reserve-now-button"
                        >
                        {{ 'addToCartItems.reserveNow' | cxTranslate }}
                      </span>
                    }
                  </button>
                }
              </section>
            </section>
          }
        </section>
      </section>
    }
  </section>
  @if (userDetails == undefined) {
    <section>
      <button type="button" class="btn blue-button" (click)="goToLogin()">
        @if (buttonName === 'Add to cart') {
          <span>
            {{ 'addToCartItems.addCart' | cxTranslate }}
          </span>
        }
        @if (buttonName === 'Login to order') {
          <span>
            {{ 'addToCartItems.loginToOrder' | cxTranslate }}
          </span>
        }
        @if (buttonName === 'Reserve now') {
          <span class="reserve-now-button">
            {{ 'addToCartItems.reserveNow' | cxTranslate }}
          </span>
        }
      </button>
    </section>
  }
</section>
